
export const config = {
  apiKey: "AIzaSyB-lpQeJN0g6jnJNG37y6xmWabd5Zs4sRM",
  authDomain: "strapp-4e040.firebaseapp.com",
  databaseURL: "https://strapp-4e040.firebaseio.com",
  projectId: "strapp-4e040",
  storageBucket: "strapp-4e040.appspot.com",
  messagingSenderId: "588022987582",
  appId: "1:588022987582:web:f36db15fe4e8b45ee68a6f",
  measurementId: "G-DBJPM32B2B"
};



// export const config = {
//   apiKey: "AIzaSyALtv1RnBsO85_BfgwV2pSZ7HiAHbT5_gU",
//   authDomain: "strapp-dev.firebaseapp.com",
//   projectId: "strapp-dev",
//   storageBucket: "strapp-dev.appspot.com",
//   messagingSenderId: "818318147434",
//   appId: "1:818318147434:web:f94b7a8e10842887096f13",
//   measurementId: "G-3CVKC1V8FT"
// };

